import { render, staticRenderFns } from "./DevCardKD1.vue?vue&type=template&id=6df621cb&scoped=true"
import script from "./DevCardKD1.vue?vue&type=script&lang=js"
export * from "./DevCardKD1.vue?vue&type=script&lang=js"
import style0 from "./DevCardKD1.vue?vue&type=style&index=0&id=6df621cb&prod&lang=css"
import style1 from "./DevCardKD1.vue?vue&type=style&index=1&id=6df621cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df621cb",
  null
  
)

export default component.exports